module.exports = __webpack_public_path__ + "static/media/Career.da77683c.jpg";